// extracted by mini-css-extract-plugin
module.exports = {"ArtistSkeleton":"ArtistSkeleton_ArtistSkeleton__3iBGZ","loading":"ArtistSkeleton_loading__3YKKo","Avatar":"ArtistSkeleton_Avatar__3krGo","Name":"ArtistSkeleton_Name__2kDUY"};